<button mat-flat-button class="flex flex_center"
	[ngClass]="{
		button_large: size=='large',
		button_medium: size=='medium',
		'mat-mdc-unelevated-button': matStyle=='mat-flat-button',
		'mat-mdc-button': matStyle=='mat-button'
	}"
	[color]="matColor"
	[type]="type"
	[disabled]="bWorking || bDisabled"
	[class]="classes"
	[style]="style | safeCss"
	(click)="emit()"
	[attr.aria-label]="bWorking ? busyCaption : caption"
	#button
	>
	
	<mat-icon matPrefix class="material-icons-outlined">
		{{ matIcon }}
	</mat-icon>
	{{ bWorking ? busyCaption : caption }}
	<mat-spinner matSuffix [ngClass]="{accent_300: matColor=='accent', black: matColor=='primary', white: matColor=='warn'}" *ngIf="bWorking" diameter="20" strokeWidth="2"></mat-spinner>
</button>